<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            if (value) {
                // console.log("value", value)
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                // console.log("selected ", selectedItem)
                if (this.field.key == 'contactInfo.cityId') {
                    if (
                        selectedItem.dataSegmentId ==
                        process.env.VUE_APP_SSA_ACCOUNT
                    ) {

                        this.$store.commit('updateField', {
                            key: 'asaanAccInfo.city',
                            value: selectedItem.value,
                        })
                    } else {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.city',
                            value: selectedItem.value,
                        })
                    }
                    this.$store.commit('updateField', {
                        key: 'contactInfo.city',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key == 'w9Info.cityId') {
                    // console.log("selected ", selectedItem)
                    this.$store.commit('updateField', {
                        key: 'w9Info.city',
                        value: selectedItem.title,
                    })
                }
            }
        },
    }, // End of Component > watch
}
</script>
